module.exports = __webpack_public_path__ + "static/media/pathIcon.1ee02350.svg";